import Category from "../category/Category";
import SidebarCategory from "../category/SidebarCategory";

const Banner = () => {
  return (
    <div className="banner-two">
      <div className="container container-lg">
        <div className="banner-two-wrapper d-flex align-items-start">
          <div className="w-265 d-lg-block d-none flex-shrink-0">
            <div className="w-265 style-two common-dropdown nav-submenu p-0 submenus-submenu-wrapper shadow-none border border-gray-100 position-relative border-top-0">
              <SidebarCategory />
            </div>
          </div>
          <Category />
        </div>
      </div>
    </div>
  );
};
export default Banner;
